import { Instance } from 'mobx-state-tree';
import { PackageDtoModelBase } from './PackageDtoModel.base';

/* The TypeScript type of an instance of PackageDtoModel */
export interface PackageDtoModelType extends Instance<typeof PackageDtoModel.Type> {}

/* A graphql query fragment builders for PackageDtoModel */
export { selectFromPackageDto, packageDtoModelPrimitives, PackageDtoModelSelector } from './PackageDtoModel.base';

/**
 * PackageDtoModel
 */
export const PackageDtoModel = PackageDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
